<template>
    <section class="grid gap-10 lg:grid-cols-[0.85fr_1.15fr] lg:gap-16" :class="color">
        <div class="max-w-xl">
            <p class="text-xs font-extrabold uppercase tracking-[0.16em] opacity-60">{{ leading }}</p>
            <h2 class="mt-4 text-4xl font-extrabold leading-tight tracking-tight sm:text-5xl">{{ title }}</h2>
        </div>
        <div class="flex min-w-0 flex-col gap-8">
            <p class="max-w-3xl text-base leading-relaxed opacity-75 sm:text-lg">{{ description }}</p>
            <div>
                <button-link class="inline-flex" :url="url">{{ cta }}</button-link>
            </div>
            <ul v-if="contents.length" class="grid gap-4">
                <li v-for="content in contents" :key="content.id" class="flex gap-4 border-t border-current/15 pt-4">
                    <div class="flex h-14 w-14 shrink-0 items-center justify-center rounded-xl bg-nomad-accent/20 p-3">
                        <img :src="content.icon" :alt="`${content.title} icon`" class="h-full w-full object-contain">
                    </div>
                    <div class="min-w-0">
                        <div class="text-sm font-extrabold uppercase tracking-[0.15em]">{{ content.title }}</div>
                        <div class="mt-1 text-sm leading-relaxed opacity-70">{{ content.description }}</div>
                    </div>
                </li>
            </ul>
        </div>
    </section>
</template>
<script>
import ButtonLink from './buttons/ButtonLink.vue';
export default {
    props: {
        leading: String,
        title: String,
        cta: String,
        description: String,
        url: String,
        color: {
            type: String,
            default: 'text-black'
        },
        contents: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            
        }
    },
    components: {
        ButtonLink
    }
}
</script>
